import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { GlobalComponent } from "../../global-component";
import { Store } from '@ngrx/store';
import { logout } from '../../store/Authentication/authentication.actions';
import { CurrentUser } from '../models/currentuser.models';
import { User } from '../models/user.models';
import { TokenStorageService } from './token-storage.service';
import { GenericService } from './generic.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';

const BASE_URL = GlobalComponent.BASE_API_URL;
const AUTH_API = BASE_URL + GlobalComponent.AUTH_API;
const VENDOR_ONBOARDING_API = BASE_URL + GlobalComponent.vendoronboarding;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: User;
    currentUserValue: any;

    private currentUserSubject: BehaviorSubject<CurrentUser>;
    public currentuser: Observable<CurrentUser>;

    constructor(private http: HttpClient, private store: Store, private tokenService: TokenStorageService, private genericService: GenericService, private afs: AngularFirestore) {
        this.currentUserSubject = new BehaviorSubject(this.tokenService.getCurrentUser());
        this.currentuser = this.currentUserSubject.asObservable();
     }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password?: string, name?: string, encryptedemail?: string, encryptedname?: string) { 
       let currentuser = this.tokenService.getCurrentUser();
       let vendorGUID = this.tokenService.getVendorGUID();
        const postData = {
            username: email,
            email: email,
            password: password,
            role: GlobalComponent.ROLES.Superadmin,
            usertype: GlobalComponent.USERTYPE.Client,
            provider: 'local',
            source: 'web',
            registereddomain: email.substring(email.lastIndexOf('@') + 1),
            name: name,
            masterguid: currentuser && currentuser?.user ? currentuser?.user?.masterguid : vendorGUID ? vendorGUID : null,
            vendorguid: vendorGUID,
            subdomain: window.location.host,
            encryptedemail: encryptedemail,
            encryptedname: encryptedname
          };
        // Register Api
        return this.http.post(AUTH_API + 'local/register', postData, httpOptions).pipe(
            map((response: any) => {
                const user = response;
                return user;
            }),
            catchError((error: any) => {
                return throwError(() => error);
            })
        );
    }

    //  /**
    //  * Performs the auth
    //  * @param email email of user
    //  * @param password password of user
    //  */
    // login(email: string, password: string) {
    //     const postData = {
    //         identifier: email,
    //         password: password,
    //         vendorguid: this.tokenService.getVendorGUID()
    //       };

    //     return this.http.post(AUTH_API + 'local', postData, httpOptions).pipe(
    //           map((response: any) => {
    //             const user : CurrentUser = response;
    //             this.currentUserSubject.next(user);
    //             return user;
    //         }),
    //         catchError((error: any) => {
    //             return throwError(() => error);
    //         })
    //     );
    // }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string): Observable<CurrentUser> {
        let vendorguid = this.tokenService.getVendorGUID();
        const postData = {
            identifier: email,
            password: password,
            vendorguid: vendorguid,
            domainurl: window.location.host
        };
    
        if (!vendorguid) {
            let domainurl = window.location.host;
            console.log('domain url', domainurl);
            return this.afs.collection("subdomains").doc(domainurl).get().pipe(
                switchMap((result: any) => {
                    console.log('firebase result', result.data());
                    if (result.data()) {
                        sessionStorage.setItem("vendorguid", result.data().guid);
                        postData['vendorguid'] = result.data().guid;
                        return this.http.post(AUTH_API + 'local', postData, httpOptions).pipe(
                            map((response: any) => {
                                const user: CurrentUser = response;
                                this.currentUserSubject.next(user);
                                return user;
                            }),
                            catchError((error: any) => {
                                return throwError(() => error);
                            })
                        );
                    } else {
                        return throwError(() => new Error('User not found'));
                    }
                })
            );
        } else {
            return this.http.post(AUTH_API + 'local', postData, httpOptions).pipe(
                map((response: any) => {
                    const user: CurrentUser = response;
                    this.currentUserSubject.next(user);
                    return user;
                }),
                catchError((error: any) => {
                    return throwError(() => error);
                })
            );
        }
    }

    /**
     * Returns the current user
     */
    public currentUser(): any {
        return this.currentUserSubject.value;
    }

    /**
     * Logout the user
     */
    logout() {
        this.store.dispatch(logout());
        this.currentUserSubject.next(null!);
        return of(undefined).pipe(
        
        );

    }

    /**
     * Forgot Password
     * @param email email of user
     */
    forgotPassword(email: string) {
        const postData = {
            email: email
          };

        return this.http.post(AUTH_API + 'forgot-password', postData, httpOptions).pipe(
              map((response: any) => {
                console.log("response", response)
                return response;
            }),
            catchError((error: any) => {
                return throwError(() => error);
            })
        );
    }

    /**
     * Reset Password
     */
    resetPassword(password: string, confirmpassword: string, code: string) {
        const postData = {
            password: password,
            passwordConfirmation: confirmpassword,
            code: code
          };

        return this.http.post(AUTH_API + 'reset-password', postData, httpOptions).pipe(
              map((response: any) => {
                console.log("response", response)
                return response;
            }),
            catchError((error: any) => {
                return throwError(() => error);
            })
        );
    }

    /**
     * Reset Password
     */
    changePassword(password: string, currentpassword: string) {
        const postData = {
            currentpassword: currentpassword,
            password: password
          };
        return this.http.post(AUTH_API + 'change-password', postData);
    }

    /**
     * Onboarding API(PUT)
     */
    vendoronboardingComplete(companyname: string, address: string, userguid: string, oprstates: any, encryptedcompany: string, encryptedaddress: string) {
        const postData = {
            company: companyname,
            address: address || '',
            guid: userguid,
            oprstates: oprstates,
            encryptedcompany: encryptedcompany,
            encryptedaddress: encryptedaddress
          };
        return this.http.put(VENDOR_ONBOARDING_API, postData);
    }

}

